module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAVBJREFUKBWNkr1Kw1AUx8//JlVQOziICFVwEhw6iIsZIjGL4KI+gQ/g6gPo4NhR8Bk6uegSLTShgwR8ABEqdHBw8QtbY3I8t3G4twj2QDhf/9/JPbkBjViSJNVBVpxKeZcYFQJfKZo6CoL1Z1OqzISZMcj4gpkO5akx8bz4g4I/r9M0rZhaC2y1Yl/gwBToWAbUXz/6e2bdAlnRqtk0Yy7Y6lkgwXkwxVYMsnoWuOV7EYguLUASqXUU15pm3QIBFEuLC/uk0BD1PQiPCjifnFDbQbDcN0HXTHTc671UHUIzJ47hQDGppyxzp6X1ZmrlFKVF7XadcjqRwo5cwchAFCCOyHGPw02vo4kheJMkK5xxLFcx9zvnTwfQu8Bh6Hu3wx35q2j8B+lJcpIZ+s7PdFx+HGBDJ2MZaE3/YeUbmWfHgkSkIXElKJvejQvKnl3N/wBLGnawMzrrPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/denglu.png
// module id = yXbF
// module chunks = 1